/**
 * Parcours de démarrage Aurélia Mail
 *
 * 1. SSO d'abord (modale) → tant que pas de session
 * 2. Splash 5 étapes fixes → après session validée
 * 3. App immédiate → archivage .eml en fond (overlay optionnel via useMailAppBoot)
 */

export const MAIL_BOOT_FADE_MS = 420;
/** Splash visuel (même timing que Chat / Agenda). */
export const MAIL_BOOT_MIN_MS = 1900;
export const MAIL_BOOT_ARCHIVE_STATS_TIMEOUT_MS = 3_500;
export const MAIL_BOOT_OPTIMIZATION_STALL_MS = 14_000;

export const MAIL_BOOT_OPT_MIN_MISSING = 1;

export const MAIL_BOOT_SESSION_KEY = "mail_boot_opened_v1";
export const MAIL_BOOT_OPT_DAY_LS_PREFIX = "mail_opt_overlay_day_";

/** Durée entre chaque étape du splash (5 fixes). */
export const WELCOME_STEP_MS = 400;

export const MAIL_ACCOUNTS_FETCH_TIMEOUT_MS = 18_000;
export const MAIL_FOLDERS_FETCH_TIMEOUT_MS = 45_000;

export type MailBootStepId =
  | "environment"
  | "accounts"
  | "folders"
  | "messages"
  | "optimization"
  | "ready";

export type MailBootStepStatus = "pending" | "active" | "done" | "skipped";

export type MailBootStepDef = {
  id: MailBootStepId;
  label: string;
  hint: string;
};

export const MAIL_BOOT_STEPS: MailBootStepDef[] = [
  {
    id: "environment",
    label: "Chargement de votre environnement",
    hint: "Connexion sécurisée à Aurélia Suite",
  },
  {
    id: "accounts",
    label: "Détection de vos comptes e-mail",
    hint: "Identification de vos boîtes mail",
  },
  {
    id: "folders",
    label: "Préparation de vos dossiers",
    hint: "Synchronisation des listes de messages",
  },
  {
    id: "messages",
    label: "Chargement de vos messages",
    hint: "Lecture depuis votre boîte mail",
  },
  {
    id: "optimization",
    label: "Optimisation en cours",
    hint: "Archivage pour une lecture fluide et hors ligne",
  },
  {
    id: "ready",
    label: "Tout est prêt",
    hint: "Ouverture de votre espace mail",
  },
];

/** 5 étapes affichées au démarrage (splash fixe post-SSO). */
export const WELCOME_BOOT_SEQUENCE: readonly MailBootStepId[] = [
  "environment",
  "accounts",
  "folders",
  "messages",
  "ready",
];

export function todayLocalKey(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

export function readOptOverlayDoneToday(): boolean {
  try {
    return localStorage.getItem(`${MAIL_BOOT_OPT_DAY_LS_PREFIX}${todayLocalKey()}`) === "1";
  } catch {
    return false;
  }
}

export function markOptOverlayDoneToday(): void {
  try {
    localStorage.setItem(`${MAIL_BOOT_OPT_DAY_LS_PREFIX}${todayLocalKey()}`, "1");
  } catch {
    /* ignore */
  }
}
